import {
  Outlet,
  createFileRoute,
  redirect,
  isRedirect,
} from '@tanstack/react-router';
import { getToken, clearToken } from '@/lib/token';
import { getMe, type MeUser } from '@/lib/auth';
import { AppShell } from '@/components/AppShell';

export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ context, location }) => {
    if (!getToken()) {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
    // Fetch me via the router's QueryClient so it's cached for child routes.
    try {
      const me = await context.queryClient.fetchQuery({
        queryKey: ['me'],
        queryFn: getMe,
      });
      if (me.user.role !== 'admin') {
        clearToken();
        throw redirect({ to: '/login' });
      }
      return { me: me.user satisfies MeUser };
    } catch (e) {
      // Re-throw redirects as-is; clear token + redirect for auth errors.
      if (isRedirect(e)) throw e;
      clearToken();
      throw redirect({ to: '/login' });
    }
  },
  component: AuthedLayout,
});

function AuthedLayout() {
  const { me } = Route.useRouteContext();

  return (
    <AppShell me={me}>
      <Outlet />
    </AppShell>
  );
}
